export const NOTIFICATIONS_API_URL = '/api/dashboard/notification-center'
